// Modules
import React from 'react'
import { FormikProps, Form, Field } from 'formik'
import { TextField } from '@dasa-health/components-react'

// Application
import { useSignUp } from 'context'
import { maskCellPhone } from 'utils'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'

// Components
import { StyledForm } from './styles'
import { SignUpFooter } from 'redesign/components/molecules/SignUpFooter'
import { useLocation } from 'react-router-dom'

export interface FormValues {
    cellphone: string
}

type FormType = FormikProps<FormValues>

export const InnerForm: React.FC<FormType> = props => {
    const { isLoading } = useSignUp()
    const { touched, errors, values, handleChange, handleSubmit, handleBlur } = props
    const isSubmitAvailabled = !errors.cellphone && !!values.cellphone
    const helperText = touched.cellphone && errors.cellphone ? errors.cellphone : ''
    const isError = touched.cellphone && errors.cellphone ? 'error' : undefined
    const { dispatchAnalyticsEvent } = useSignUpAnaytics()
    const { pathname } = useLocation()
    const nameEvent = (pathName: string) => {
        if (pathName === '/recuperar-senha') {
            return 'reset_password'
        }
        return 'cadastro_web'
    }

    const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.target.value = maskCellPhone(event.target.value)
        handleChange(event)
    }

    return (
        <StyledForm>
            <Form autoComplete="off" onSubmit={handleSubmit}>
                <div className="form__phone">
                    <Field
                        as={TextField}
                        className="form__phone__field"
                        data-testid="cellphone-input"
                        helperText={helperText}
                        inputmode="numeric"
                        label="Celular"
                        maxLength={15}
                        name="cellphone"
                        onBlur={(e: Event) => {
                            handleBlur(e)
                            dispatchAnalyticsEvent('setPhoneOnFieldBlur', {
                                name: nameEvent(pathname),
                                errorMessage: errors.cellphone,
                            })
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFieldChange(e)}
                        type="tel"
                        value={values.cellphone}
                        variant={isError}
                    />
                </div>
                <SignUpFooter
                    isSubmitButtonDisabled={!isSubmitAvailabled}
                    isSubmitButtonLoading={isLoading}
                    submitButtonText="Validar"
                />
            </Form>
        </StyledForm>
    )
}
